import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import { INSERT_EQUIPMENTS, LOAD_ALL_EQUIPMENTS } from "./actionTypes";
import { InsertEquipmentSuccess, equipmentsApiError, loadAllEquipmentsSuccess } from "./actions";
import { postSubmitForm } from "../../helpers/forms_helper";
import showNotification from "../../helpers/show_notification";


function* insertEquipments({payload:{user}}) {
  // return
  try {
    let url = process.env.REACT_APP_BASEURL + "equipments/insert";
    const response = yield call(postSubmitForm, url,user);
    if (response.status === 1) {
      yield put(InsertEquipmentSuccess(response.data));
      showNotification(response.message,"Success")
      // yield *loadAllEquipments();
    } else {
      showNotification(response.message, "Error");
      yield put(equipmentsApiError(response));
    }
  } catch (error) {
    showNotification(error.message, "Error");
    yield put(equipmentsApiError(error));
  }
}

//Load All Equipments
function* loadAllEquipments({payload}) {
  try {
    let url = process.env.REACT_APP_BASEURL + "equipments/getall";
    const response = yield call(postSubmitForm, url,payload);
    if (response.status === 1) {
      yield put(loadAllEquipmentsSuccess(response.data));
    } else {
      showNotification(response.message, "Error");
      yield put(equipmentsApiError(response));
    }
  } catch (error) {
    showNotification(error.message, "Error");
    yield put(equipmentsApiError(error));
  }
}


function* watchLoadEquipments() {
  yield takeEvery(LOAD_ALL_EQUIPMENTS, loadAllEquipments);
}
function* watchInsertEquipments() {
  yield takeEvery(INSERT_EQUIPMENTS, insertEquipments);
}
function* equipmentsSaga() {
  yield all([
    fork(watchLoadEquipments),
    fork(watchInsertEquipments),
  ]);
}

export default equipmentsSaga;
